import { Component } from "react"
import { root } from "../../services/Globals"

export default class GetAudiotracks extends Component {
  constructor(props) {
    super(props)
    this.initialState = {
      mode: `loading`,
      payload: undefined,
    }
    this.state = this.initialState
  }

  render = () => {
    const {
      state: { mode, payload },
      reload,
    } = this

    return this.props.children({
      mode,
      payload,
      reload,
    })
  }

  componentDidMount = () => {
    const { versionId } = this.props
    window.addEventListener(`update:${ versionId }:audiotracks`, this.getData)
    return this.getData()
  }

  componentWillUnmount = () => {
    const { versionId } = this.props
    window.removeEventListener(`update:${ versionId }:audiotracks`, this.getData)
  }

  getData = () => {
    this.setState(previousState => ({
      ...previousState,
      loading: true,
    }))

    const arrangementId = this.props.arrangementId
    const versionId = this.props.versionId

    return root.wav
      .api({
        url: `/arrangements/${ arrangementId }/versions/${ versionId }/audiotracks`,
      })
      .then(({ data }) => {
        this.setState(previousState => ({
          ...previousState,
          mode: `success`,
          payload: data,
        }))
      })
      .catch(error => {
        this.setState(previousState => ({
          ...previousState,
          mode: `error`,
          payload: error,
        }))
      })
  }

  reload = event => {
    event && event.preventDefault && event.preventDefault()
    this.setState(() => this.initialState)
    return this.getData()
  }
}
